var _defs, _circle, _rect, _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    id: "svg7767",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7771"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 46.5,
    r: 44.5,
    stroke: "#42C0EF",
    strokeWidth: 3,
    id: "circle7765"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g8864",
    transform: "translate(18.57542,24.521791)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.65918,
    y: 1.76636,
    width: 52.5308,
    height: 40.423698,
    rx: 4.3938799,
    stroke: "#42c0ef",
    strokeWidth: 2.63633,
    id: "rect6600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1.1716643,39.49517 23.545874,21.97817 1.1716643,4.4612502",
    stroke: "#42c0ef",
    strokeWidth: 2.69492,
    id: "path6725"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.079124,
    y1: 21.978209,
    x2: 53.508144,
    y2: 21.978209,
    stroke: "#42c0ef",
    strokeWidth: 2.69492,
    id: "line6475"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCz);
export default __webpack_public_path__ + "static/media/cz.d0ac6d3bdec00526e71efbb8a6cd918d.svg";
export { ForwardRef as ReactComponent };